export { EditTripDetailsComponent } from './edit-trip-details.component';


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/typescript/policy-edit/trip-details/index.ts